import React from 'react';

export const quickViewDiv = (props) => {

    return (
        props.shouldShow ?
        (props.highlightValue ?
            <div>
           <label>{props.name+": "}</label>
           <span> <label style={props.highlightStyle}>{props.value} </label></span>
       </div>
         :
         <div>
            <label>{props.name+": "}</label>
            <span> {props.value}</span>
        </div>
        ) : ""
        
    );

}

export default quickViewDiv;